/* tslint:disable */
/* eslint-disable */
/**
 * Search v2
 * Search v2
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../../../runtime';

export interface SearchRequest {
	xINFAORGID: string;
	xINFASEARCHLANGUAGE: SearchXINFASEARCHLANGUAGE;
	body: string;
	xINFATID?: string;
	xINFATRACEEVENT?: string;
	xINFATGID?: string;
}

/**
 *
 */
export class HybridSearchApi extends runtime.BaseAPI {
	/**
	 */
	async searchRaw(requestParameters: SearchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
		if (requestParameters.xINFAORGID === null || requestParameters.xINFAORGID === undefined) {
			throw new runtime.RequiredError('xINFAORGID', 'Required parameter requestParameters.xINFAORGID was null or undefined when calling search.');
		}

		if (requestParameters.xINFASEARCHLANGUAGE === null || requestParameters.xINFASEARCHLANGUAGE === undefined) {
			throw new runtime.RequiredError(
				'xINFASEARCHLANGUAGE',
				'Required parameter requestParameters.xINFASEARCHLANGUAGE was null or undefined when calling search.',
			);
		}

		if (requestParameters.body === null || requestParameters.body === undefined) {
			throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling search.');
		}

		const queryParameters: any = {};

		const headerParameters: runtime.HTTPHeaders = {};

		headerParameters['Content-Type'] = 'application/json';

		if (requestParameters.xINFAORGID !== undefined && requestParameters.xINFAORGID !== null) {
			headerParameters['X-INFA-ORG-ID'] = String(requestParameters.xINFAORGID);
		}

		if (requestParameters.xINFASEARCHLANGUAGE !== undefined && requestParameters.xINFASEARCHLANGUAGE !== null) {
			headerParameters['X-INFA-SEARCH-LANGUAGE'] = String(requestParameters.xINFASEARCHLANGUAGE);
		}

		if (requestParameters.xINFATID !== undefined && requestParameters.xINFATID !== null) {
			headerParameters['X-INFA-TID'] = String(requestParameters.xINFATID);
		}

		if (requestParameters.xINFATRACEEVENT !== undefined && requestParameters.xINFATRACEEVENT !== null) {
			headerParameters['X-INFA-TRACEEVENT'] = String(requestParameters.xINFATRACEEVENT);
		}

		if (requestParameters.xINFATGID !== undefined && requestParameters.xINFATGID !== null) {
			headerParameters['X-INFA-TG-ID'] = String(requestParameters.xINFATGID);
		}

		if (this.configuration && this.configuration.apiKey) {
			headerParameters['IDS-USER-TOKEN'] = this.configuration.apiKey('IDS-USER-TOKEN'); // userToken authentication
		}

		if (this.configuration && this.configuration.apiKey) {
			headerParameters['IDS-AGENT-SESSION-ID'] = this.configuration.apiKey('IDS-AGENT-SESSION-ID'); // agentSessionId authentication
		}

		if (this.configuration && this.configuration.apiKey) {
			headerParameters['IDS-SERVICE-TOKEN'] = this.configuration.apiKey('IDS-SERVICE-TOKEN'); // serviceToken authentication
		}

		if (this.configuration && this.configuration.accessToken) {
			const token = this.configuration.accessToken;
			const tokenString = await token('bearerAuth', []);

			if (tokenString) {
				headerParameters['Authorization'] = `Bearer ${tokenString}`;
			}
		}
		const response = await this.request(
			{
				path: `/api/v1/search`,
				method: 'POST',
				headers: headerParameters,
				query: queryParameters,
				body: requestParameters.body as any,
			},
			initOverrides,
		);

		if (this.isJsonMime(response.headers.get('content-type'))) {
			return new runtime.JSONApiResponse<string>(response);
		} else {
			return new runtime.TextApiResponse(response) as any;
		}
	}

	/**
	 */
	async search(requestParameters: SearchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
		const response = await this.searchRaw(requestParameters, initOverrides);
		return await response.value();
	}
}

/**
 * @export
 * @enum {string}
 */
export enum SearchXINFASEARCHLANGUAGE {
	Gremlin = 'gremlin',
	Elasticsearch = 'elasticsearch',
	KnowledgeGraphSearch = 'knowledge-graph-search',
}
